import type { FaireProductEntity } from "../../entity_types/product";

export const p_fmk7bx2qkw: FaireProductEntity = {
  token: "p_fmk7bx2qkw",
  type: "product",
  name: "Bible Stories for Little Ones: Baby’s First Bible Board Book",
  brandToken: "b_d93d4i84y7",
  brandName: "Paper Peony Press",
  imageUrl:
    "https://cdn.faire.com/fastly/41fd7f54a71f6e3122c515fe58e8c8f5fe8460b02173d830e3e7398f51c60cd0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bbc2fadf9d1da91f5a9a0117f2d9dd360b2851b98730b8dae862e14e4cd22e67.jpeg",
    "https://cdn.faire.com/fastly/e0ef8afc8cdfb0b9bebd30c402044e594c5f777f89e2f09aeb5fe0aa5c60acb7.jpeg",
    "https://cdn.faire.com/fastly/f9ae334a2cff0055eea792b9acd337aed96a36f6f3dc43dc7ed73947560808f7.jpeg",
    "https://cdn.faire.com/fastly/a9773173c6004727c87ed2ead89a3676f8b2375d196687dea53fa22c9e09bb81.jpeg",
    "https://cdn.faire.com/fastly/d1720f0deb30f2e0e92f733dbfe8a99de4b764b3dca4eaf89ee36cabafbe8eba.jpeg",
    "https://cdn.faire.com/fastly/04456f4340923fd13b75311a45cc8669d5cb407e828b01d09a91492c57b280c1.jpeg",
    "https://cdn.faire.com/fastly/ec7b6059c0a3c0a8d2982e56de2d51f11e37397034765f34e26342314ff6fce1.jpeg",
    "https://cdn.faire.com/fastly/4785be53e3bf5de918d38805cd7e72bc850d2d16a3d9d29c5f0ba241b9492758.jpeg",
    "https://cdn.faire.com/fastly/c5685158520499c1e41de8fa6b599888ac721001acbc180d6935b52e3d533987.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "Enhance your collection with our captivating board book, perfect for little ones. Illustrated by Martha Ratcliff, it narrates key moments from the creation story to Jesus's miracles, culminating in his second coming. Each story, tailored for children, highlights God's love. This keepsake boasts a gold foil-adorned cover, adding elegance. Whether for bedtime or morning readings, these concise tales engage children in the greatest love story. Ideal for baby showers, birthdays, baptisms, and more, it's a cherished gift for celebrating faith's joy. Elevate your offerings with this keepsake-quality book. ",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:33.564Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
